export const theme =
{
    code: '',
    heading: {
        h1: '',
        h2: '',
        h3: '',
        h4: '',
        h5: '',
    },
    image: '',
    link: '',
    list: {
        listitem: '',
        nested: {
            listitem: '',
        },
        ol: '',
        ul: '',
    },
    ltr: '',
    paragraph: '',
    placeholder: '',
    quote: '',
    rtl: '',
    text: {
        bold: '',
        code: '',
        hashtag: '',
        italic: '',
        overflowed: '',
        strikethrough: '',
        underline: '',
        underlineStrikethrough: '',
    },
    layoutContainer: '',
    layoutItem: '',
    // table: '',
    table: '',
    tableAddColumns: '',
    tableAddRows: '',
    tableAlignment:
    {
        center: '',
        right: '',
    },
    tableCell: '',
    tableCellActionButton: '',
    tableCellActionButtonContainer: '',
    tableCellHeader: '',
    tableCellResizer: '',
    tableCellSelected: '',
    tableFrozenColumn: '',
    tableFrozenRow: '',
    tableRowStriping: '',
    tableScrollableWrapper: '',
    tableSelected: '',
    tableSelection: '',
};